module.exports = __webpack_public_path__ + "59c9f538d7be41f09009d34c4e082c9f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/pretzel.png
// module id = 2591
// module chunks = 0